const columns = [
  {
    title: '工单ID',
    dataIndex: 'workOrderId',
    key: 'workOrderId',
    slots: {
      customRender: 'workOrderId'
    },
    fixed: 'left',
    width: 150
  },
  {
    title: 'ERP编号',
    dataIndex: 'belongErpSn',
    key: 'belongErpSn',
    width: 150
  },
  {
    title: '姓名',
    dataIndex: 'acceptorName',
    key: 'acceptorName',
    width: 150
  },
  {
    title: '关联健管工单ID',
    dataIndex: 'daWorkOrderId',
    key: 'daWorkOrderId',
    width: 150
  },
  {
    title: '工单类型',
    dataIndex: 'businessTypeDesc',
    key: 'businessTypeDesc',
    width: 150
  },
  {
    title: '工单创建时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 220
  },
  {
    title: '工单处理时间',
    dataIndex: 'dealTime',
    key: 'dealTime',
    width: 220
  },
  {
    title: '工单过期时间',
    dataIndex: 'timeoutTime',
    key: 'timeoutTime',
    width: 220
  },
  {
    title: '工单完成时间',
    dataIndex: 'completeTime',
    key: 'completeTime',
    width: 220
  },
  {
    title: '工单失效时间',
    dataIndex: 'failureTime',
    key: 'failureTime',
    width: 220
  },
  {
    title: '工单状态',
    dataIndex: 'workOrderStatusDesc',
    key: 'workOrderStatusDesc',
    width: 150
  }
]
const paginationConfig = {
  current: 1,
  pageSize: 20,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
}
export { columns, paginationConfig }
